import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { del } from "sr/utils/axios";

export const deleteMessage = async (data: {
  recipient_id: string;
  id: string;
}) => {
  try {
    const res = await del<ApiResponse<[]>>(`/chatmessage`, data);

    if (res?.success === true) {
      return res;
    } else {
      return null;
    }
  } catch (e: any) {
    HandleApiError(e);
  }
};
